// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "container-3ssof";
var _4 = "card-WfzFE";
var _5 = "content-3ULIQ";
var _6 = "footer-XBlRB";
var _7 = "links-1KVI2";
var _8 = "button-2TGOb";
var _9 = "modal_scrollBody-n2Yck";
var _a = "modal_paper-3HL9B";
var _b = "modal_recovery_paper-3Me5A";
var _c = "modal_connect_paper-1iKlK";
var _d = "menu-3DHmA";
export { _1 as "__esModule", _2 as "mobile", _3 as "container", _4 as "card", _5 as "content", _6 as "footer", _7 as "links", _8 as "button", _9 as "modal_scrollBody", _a as "modal_paper", _b as "modal_recovery_paper", _c as "modal_connect_paper", _d as "menu" }
export default { "__esModule": _1, "mobile": _2, "container": _3, "card": _4, "content": _5, "footer": _6, "links": _7, "button": _8, "modal_scrollBody": _9, "modal_paper": _a, "modal_recovery_paper": _b, "modal_connect_paper": _c, "menu": _d }
